import { motion } from 'framer-motion';
import React from 'react';
import './WorkCard.css';
import images from '../../../Utils/Images';
import TechIcon from '../../../Utils/Icons/Icons';

const WorkCard = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 60, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="workCardSection">
      <motion.div
        className='workHeader'
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7 }}
      >
        <div className="workContent">
          <h1>
            See Our Work in Action by<br/>
            <span>Turning Ideas into Reality.</span>
          </h1>
          <p>
            Explore real-world results we've delivered for startups across industries—from idea to launch.
          </p>
        </div>
      </motion.div>

      <motion.div
        className="workGridContainer"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
      >
        {/* div 1 */}
        <motion.div
          className="workSimpleBox workBoxWithImage"
          variants={itemVariants}
        >
          <h2 className="workBoxTitle">Excellence Across the Globe</h2>
          <p className="workBoxDescription">
           Our work spans continents, delivering unmatched quality and innovation. 
           See the impact of our projects around the world.
          </p>
          <div className="workImageContainer">
            <img src={images.globe2} alt="globe" className="workBoxImage" />
          </div>
        </motion.div>
        
        {/* div 2 */}
        <motion.div
          className="workSimpleBox workBoxWithImage "
          variants={itemVariants}
        >
          <h2 className="workBoxTitle">Complete Control, Seamless Delivery</h2>
          <p className="workBoxDescription"> From web to mobile, we deliver solutions that meet your
             vision with precision and excellence.</p>
          <div className="workImageContainer">
            <img src={images.phone} alt="Phone" className="workBoxImage workPhoneImage" />
          </div>
        </motion.div>
        {/* div 3 */}
        <motion.div
          className="workSimpleBox workStackBox"
          variants={itemVariants}
        >
          <h2 className="workBoxTitle">Seamless Integration with Your Stack</h2>
          <p className="workBoxDescription">
          Built on modern web standards, that ensures smooth integration across diverse
           environments without unnecessary dependencies or conflicts.
          </p>
          <div className="iconGrid">
            <div className="iconColumn">
              <div className="iconBox"><TechIcon name="md-vpn-key" /></div>
              <div className="iconBox"><TechIcon name="mail" /></div>
            </div>
            <div className="iconColumn">
              <div className="iconBox"><TechIcon name="python" /></div>
              <div className="iconBox"><TechIcon name="tailwind" /></div>
              <div className="iconBox"><TechIcon name="figma" /></div>
            </div>
            <div className="iconColumn">
              <div className="iconBox"><TechIcon name="ruby" /></div>
              <div className="iconBox"><TechIcon name="nodejs" /></div>
            </div>
            <div className="iconColumn">
              <div className="iconBox"><TechIcon name="blender" /></div>
              <div className="iconBox"><TechIcon name="react" /></div>
              <div className="iconBox"><TechIcon name="html5" /></div>
            </div>
            <div className="iconColumn">
              <div className="iconBox"><TechIcon name="typescript" /></div>
              <div className="iconBox"><TechIcon name="java" /></div>
            </div>
          </div>
        </motion.div>
        
        {/* div 4 */}
        <motion.div
          className="workSimpleBox"
          variants={itemVariants}
        >
          <h2 className="workBoxTitle">Real time support</h2>
          <p className="workBoxDescription">Our team is available whenever you need assistance.  
           Fast, reliable, and ready to solve any challenge.</p>
          <div className="workImageContainer">
            <img src={images.chat} alt="chat" className="workBoxImage" />
          </div>
        </motion.div>

        <motion.div
          className="workSimpleBox workFullWidth workBoxWithImage"
          variants={itemVariants}
        >
          <h2 className="workBoxTitle">Driving Impact Everywhere</h2>
          <p className="workBoxDescription">
            Our work empowers businesses to grow, innovate, and succeed
             with solutions tailored to their unique needs.
          </p>
          <div className="workImageContainer workCodeImageContainer">
            <img src={images.code} alt="Code" className="workBoxImage workCodeImage" />
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}

export default WorkCard;
